import { useCallback, useEffect } from 'react';

import {
  useApiDelete,
  useApiGet,
  useApiPatch,
  useApiPost
} from '../../common/api/Api.hooks';
import { PaginatedList } from '../../common/PaginatedList.interface';
import { Role, RoleCreateDto } from './Role.interface';

export function useFindRoles(shouldFetchOnMount = false) {
  const { data, isLoading, error, get } =
    useApiGet<PaginatedList<Role>>('users/roles');
  useEffect(() => {
    if (shouldFetchOnMount) {
      get();
    }
  }, [get, shouldFetchOnMount]);
  return { roleList: data, isLoading, error, get };
}

export function useCreateRole() {
  const { data, post, ...result } = useApiPost<Role>('users/roles');
  const createRole = useCallback((dto: RoleCreateDto) => post(dto), [post]);
  return { ...result, role: data, createRole };
}

export function useUpdateRole(id: number) {
  const { data, patch, ...result } = useApiPatch<Role>(`users/roles/${id}`);
  const updateRole = useCallback((dto: RoleCreateDto) => patch(dto), [patch]);
  return { ...result, role: data, updateRole };
}

export function useDeleteRole(id: number) {
  const { data, ...result } = useApiDelete<Role>(`users/roles/${id}`);
  return { ...result, role: data };
}
